const zh = {
	risk: {
		riskTitle: '黑名单',
		group: '群组',
		store: '网站',
		omniStore: '门店/网站',
		type: '维度',
		status: '状态',
		invalidText: '若置为“失效”，当持卡人提交新交易时，该规则下的交易将不再自动拦截',
		enableText: '若置为“生效”，该黑名单规则即刻生效',
		title_enable: '生效',
		title_invalid: '失效',
		success: '操作成功',
		notUpload: '您还未上传文件，无法提交!',
		downloadFile: '下载模板',
		bulkUploadText: '请先下载模板文件，并按要求填写后，再上传',
		bulkTitle: '批量上传',

		data: '数据',
		country: '国家',
		state: '省份/州',
		city: '城市',
		adrress: '详细地址',
		format: '卡号支持以下两种格式:',
		format1: '1.完整卡号, 例如: “1234567890123456”',
		format2: '2.前六位数字-****-后4位数字，例如: “123456****1234”',
		applyTo: '适用全部网站',
		omniApplyTo: '适用全部门店和网站',
		applyAll: '若勾选此项，当前配置的黑名单规则适用于未来新增的每一个网站',
		omniApplyAll: '若勾选此项，当前配置的黑名单规则适用于未来新增的每一个门店和网站',

		cancel: '取消',
		save: '保存'
	},
	button: {
		add: '新增',
		bulkAdd: '批量新增',
		enable: '生效',
		disable: '失效',
		introduction: '黑名单维度说明'

	},
	table: {
		type: '维度',
		rule: '规则',
		store: '适用网站',
		omniStore: '适用门店/网站',
		createTime: '创建时间',
		updateTime: '更新时间',
		operator: '操作人',
		status: '状态',
		action: '操作',
		edit: '编辑'
	},
	introduction: {
		title: '黑名单操作指南',
		tip1: '若交易订单命中黑名单规则，此笔交易订单将被拦截，无法继续进行交易，请谨慎添加黑名单规则。',
		tip2: '只能针对当前您拥有权限的网站进行黑名单的查看、添加、修改等操作',
		omniTip2: '只能针对当前您拥有权限的门店和网站进行黑名单的查看、添加、修改等操作',
		q1: '1、黑名单维度释义',
		q2: '2、在哪里找到以上信息？',
		q2Desc: '找到菜单栏，依次点击：交易管理 -> 交易查询 -> 交易流水号，跳转到 “交易明细” 页面',
		q3: '3、在哪里找到 Acc ID？',
		q3Desc: '在菜单栏 “网站管理”，找到您要配置黑名单规则的网站，查看对应Acc ID',
		omniQ3Desc: '在菜单栏 “门店/网站管理”，找到您要配置黑名单规则的门店/网站，查看对应Acc ID',
		card: '卡号',
		card_desc: '完整卡号、前6位****后4位',
		card_example: '1234567890123456、123456****1234',
		phone: '电话',
		phone_desc: '收货人电话号码',
		phone_example: '8617700000000',
		email: '邮箱',
		email_desc: '收货人邮箱',
		email_example: 'XXX@hotmail.com',
		emailDomain: '邮箱域名',
		emailDomain_desc: '收货人邮箱域名',
		emailDomain_example: 'hotmail.com',
		address: '收货地址',
		address_desc: '收货人地址，包含国家、省份、城市、街道',
		address_example: '中国，浙江省，杭州市，滨江区江陵路567号三楼',
		type: '维度',
		desc: '释义',
		example: '例子',
		comfirm: '确认'
	}
}

export default zh
